import { BaseModel } from "@/store/feathers/feathers.client.js";
/* eslint-disable no-useless-escape, no-unused-vars */

export default class MerchantSettings extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "MerchantSettings";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {};
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    store.state.ids.merchant_settings_id = data.id
    store.state.billing.recurring_settings_id = data.recurring_settings_id
    store.state.billing.invoice_settings_id = data.invoice_settings_id
    store.state.product.cart_settings_id = data.cart_settings_id
    store.state.billing.contract_settings_id = data.contract_settings_id
    store.state.customer.settings_id = data.customer_settings_id
    store.state.billing.donation_settings_id = data.donation_settings_id
    store.state.ids.email_settings_id = data.email_settings_id
    store.state.billing.form_settings_id = data.form_settings_id
    store.state.billing.installment_settings_id = data.installment_settings_id
    store.state.ids.message_settings_id = data.message_settings_id
    store.state.ids.notification_settings_id = data.notification_settings_id
    store.state.billing.order_settings_id = data.order_settings_id
    store.state.ids.phone_settings_id = data.phone_settings_id
    store.state.ids.product_settings_id = data.product_settings_id
    store.state.ids.receipt_settings_id = data.receipt_settings_id
    store.state.ids.shipping_settings_id = data.shipping_settings_id
    store.state.ids.subscription_settings_id = data.subscription_settings_id
    store.state.ids.fee_settings_id = data.fee_settings_id
    store.state.ids.discount_settings_id = data.discount_settings_id
    store.state.ids.tax_settings_id = data.tax_settings_id
    store.state.ids.transaction_settings_id = data.transaction_settings_id
    store.state.ids.user_settings_id = data.user_settings_id

    if (data.menu) store.state.config.menu = data.menu
    if (data.style) store.state.config.style = data.style

    return data;
  }
}
